module.exports = __webpack_public_path__ + "img/nas_pristup.14753ca6.jpg";